import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-moveup-button-sm',
  templateUrl: './moveup-button-sm.component.html',
  styleUrls: ['./moveup-button-sm.component.scss']
})
export class MoveUpButtonSmComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
